import React, { useState, useEffect, useCallback } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./DemoUploadHuur.css";
import { Trans, useTranslation } from "react-i18next";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import DeleteIcon from "@mui/icons-material/Delete";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import DemoErrorModal from "./DemoErrorModal";
import DemoLoadingModal from "./DemoLoadingModal";

import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Divider,
  Typography,
} from "@mui/material";
import DropzoneUploader from "../DropzoneUploader";
// import FormAS from "./FormAS";

const REACT_APP_BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const DemoUploadHuur = () => {
  const navigate = useNavigate();
    const { search } = useLocation();
  
  const { t, i18n } = useTranslation();
  const [runConfig, setRunConfig] = useState({});
  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.between("mobile", "ipad"));

  const [showErrorModal, setShowErrorModal] = useState(false);
  const [createRequestLoading, setCreateRequestLoading] = useState(false);
  const [startRunLoading, setStartRunLoading] = useState(false);
  const [error, setError] = useState(null);
  const [requestId, setRequestId] = useState(null);

  function handleBack() {
    window.scrollTo({ top: 0, behavior: "smooth" });
    navigate(`/huurovereenkomst/${search}`);
  }

  async function createRequest() {
    setCreateRequestLoading(true);

    const formData = new FormData();
    formData.append(
      "run_config",
      JSON.stringify({
        language: i18n.language,
      })
    );

    try {
      const response = await fetch(
        `${REACT_APP_BACKEND_URL}/run/create_request_welocate`,
        {
          method: "POST",
          body: formData,
        }
      );

      if (!response.ok) {
        const responseData = await response.json();
        throw new Error(responseData.detail || "Request failed.");
      }

      const data = await response.json();
      setRequestId(data);
    } catch (err) {
      setError(err.message || "Something went wrong.");
      setShowErrorModal(true);
    } finally {
      setCreateRequestLoading(false);
    }
  }

  const startRun = useCallback(async () => {
    setStartRunLoading(true);
    setError(null);

    const formData = new FormData();
    formData.append("contract_file", runConfig.contract_file);
    formData.append(
      "run_config",
      JSON.stringify({
        name: "MAATWERK",
        email: "info@checkyourterms.com",
        license_plate: "",
        purchase_type: "PARTICULIER",
        language: i18n.language,
        agreed_gtc: runConfig.agreed,
        agreed_disclaimer: runConfig.agreed,
      })
    );

    try {
      const response = await fetch(
        `${REACT_APP_BACKEND_URL}/run/start_welocate/${requestId}`,
        {
          method: "POST",
          body: formData,
        }
      );

      if (!response.ok) {
        const responseData = await response.json();
        throw new Error(responseData.detail || "Request failed.");
      }

      const data = await response.json();

      navigate("/huurovereenkomst/results/" + requestId);
    } catch (err) {
      setError(err.message || "Something went wrong.");
      setShowErrorModal(true);
    } finally {
      setStartRunLoading(false);
    }
  }, [runConfig, i18n.language, requestId, navigate]);

  useEffect(() => {
    if (requestId) {
      startRun();
    }
  }, [requestId, startRun]);

  const handleFileChange = useCallback((file) => {
    setRunConfig((prev) => ({ ...prev, contract_file: file[0] }));
  }, []);

  return (
    <div className="nc-container" style={{ marginTop: 0 }}>
      <DemoErrorModal
        visible={showErrorModal}
        setVisible={() => {
          setShowErrorModal(false);
        }}
        errorMsg={error}
        unsetRequestId={() => setRequestId(null)}
      />
      <DemoLoadingModal
        requestId={requestId}
        visible={startRunLoading}
        setVisible={setStartRunLoading}
      />

      <div className="nc-form-input">
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "4px",
            marginBottom: "8px",
          }}
        >
          <Typography
            sx={{ fontSize: "24px", fontWeight: 500, color: "#439BD9" }}
          >
            {t("maatwerkUpload.pageTitle.rental")}
          </Typography>
        </div>
        <Divider />
      </div>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "8px",
          padding: "0px 12px",
        }}
      >
        <span className="nc-inputs-title mt-1">
          <UploadFileIcon sx={{ color: "#439BD9" }} />
          Upload document
        </span>
        <Typography sx={{ fontSize: "14px" }}>
          {t("maatwerkUpload.uploadText")}
        </Typography>
      </Box>

      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: "40px",
          justifyContent: "center",
          padding: "0px 12px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "24px",
            flex: 1,
            minWidth: "320px",
          }}
        >
          <div className="nc-upload-container">
            <div className="nc-upload-field mb-1">
              {runConfig.contract_file ? (
                <div
                  className="nc-file-uploaded"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: "16px 20px",
                    backgroundColor: "#F0F7FC",
                    border: "2px solid #DCEDFA",
                    borderRadius: "12px",
                    minHeight: "80px",
                    width: mobile ? "100%" : "90%",
                    minWidth: 0,
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "12px",
                      minWidth: 0,
                      flex: 1,
                      overflow: "hidden",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: "40px",
                        height: "40px",
                        backgroundColor: "#439BD9",
                        borderRadius: "8px",
                        flexShrink: 0,
                      }}
                    >
                      <UploadFileIcon
                        sx={{ color: "#fff", fontSize: "20px" }}
                      />
                    </div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "2px",
                        minWidth: 0,
                        flex: 1,
                        overflow: "hidden",
                      }}
                    >
                      <span
                        style={{
                          fontSize: "14px",
                          fontWeight: 500,
                          color: "#0F3A58",
                          lineHeight: "1.2",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          maxWidth: "50vw",
                        }}
                      >
                        {runConfig?.contract_file?.name || ""}
                      </span>
                      <span
                        style={{
                          fontSize: "12px",
                          color: "#6B7280",
                          fontWeight: 400,
                        }}
                      >
                        {runConfig?.contract_file?.size
                          ? `${Math.round(
                              runConfig.contract_file.size / 1024
                            )} KB`
                          : "Bestand geüpload"}
                      </span>
                    </div>
                  </div>
                  <DeleteIcon
                    onClick={() =>
                      setRunConfig({ ...runConfig, contract_file: null })
                    }
                    sx={{
                      cursor: "pointer",
                      color: "#6B7280",
                      fontSize: "20px",
                      flexShrink: 0,
                      "&:hover": { color: "#EF4444" },
                    }}
                  />
                </div>
              ) : (
                <DropzoneUploader
                  onFileChange={handleFileChange}
                  minHeight="320px"
                />
              )}
            </div>
          </div>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "24px",
            flex: 1,
            minWidth: "320px",
          }}
        >
          <Box
            sx={{
              background: "#F0F7FC",
              padding: "24px",
              borderRadius: "8px",
              width: "100%",
              fontSize: "14px",
              minHeight: "320px",
            }}
          >
            <b>Disclaimer</b>
            <p
              style={{
                lineHeight: "160%",
                fontSize: "14px",
                fontWeight: 300,
              }}
            >
              {t("testDisclaimerLong")} {t("testDisclaimerLong2")}
            </p>

            <FormControlLabel
              control={
                <Checkbox
                  sx={{
                    color: "#439BD9",
                    justifyContent: "start",
                  }}
                />
              }
              label={
                i18n.language === "nl" ? (
                  <Typography sx={{ lineHeight: "1.8", fontSize: "14px" }}>
                    <Trans
                      i18nKey="avwAkkoord"
                      components={{
                        avw: (
                          <a
                            target="_blank"
                            rel="noopener noreferrer"
                            href="https://voorwaardenchecker.nl/nl/algemene-voorwaarden"
                          >
                            Algemene Voorwaarden
                          </a>
                        ),
                        privacyverklaring: (
                          <a
                            target="_blank"
                            rel="noopener noreferrer"
                            href="https://voorwaardenchecker.nl/nl/privacyverklaring"
                          >
                            Privacyverklaring
                          </a>
                        ),
                      }}
                    />
                  </Typography>
                ) : (
                  <Typography sx={{ lineHeight: "1.8", fontSize: "14px" }}>
                    <Trans
                      i18nKey="avwAkkoord"
                      components={{
                        avw: (
                          <a
                            target="_blank"
                            rel="noopener noreferrer"
                            href="https://checkyourterms.com/en/terms-and-conditions"
                          >
                            Terms and Conditions
                          </a>
                        ),
                        privacyverklaring: (
                          <a
                            target="_blank"
                            rel="noopener noreferrer"
                            href="https://checkyourterms.com/en/privacy-statement"
                          >
                            Privacy statement
                          </a>
                        ),
                      }}
                    />
                  </Typography>
                )
              }
              checked={runConfig?.agreed}
              onChange={(e) =>
                setRunConfig({
                  ...runConfig,
                  agreed: e.target.checked,
                })
              }
              sx={{
                display: "flex",
                gap: "10px",
                alignItems: "start",
                "& .MuiFormControlLabel-label": {
                  fontWeight: 700,
                },
              }}
            />
          </Box>

          <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "flex-end",
              gap: "12px",
              marginTop: "12px",
            }}
          >
            <Button
              variant="outlined"
              sx={{
                borderRadius: "40px",
                textTransform: "none",
                borderColor: "#439BD9",
                color: "#439BD9",
              }}
              onClick={handleBack}
            >
              {t("terug")}
            </Button>
            <Button
              variant="contained"
              color="secondary"
              sx={{
                color: "#fff",
                borderRadius: "40px",
                textTransform: "none",
              }}
              onClick={createRequest}
              disabled={
                !runConfig?.contract_file ||
                !runConfig?.agreed ||
                createRequestLoading ||
                startRunLoading
              }
            >
              {t("starten")}
            </Button>
          </Box>
        </Box>
      </Box>
    </div>
  );
};

export default DemoUploadHuur;
